import React, { useState } from "react";
import { Input, Select, CheckBox } from "@speedoc/design-assets";
import { ArrowRight } from "@speedoc/design-assets/build/icons";
import Four0Four from "../404";
import Loader from "./loader";
import sendEmail from "../../utils/sendEmail";
import { trackCustom } from "../../services/analytics";
import { useCms } from "../../hooks/useCms";
import { GlobalStore } from "../../stores/global";
import { LazyLoadImage } from "react-lazy-load-image-component";

export default function ContactFormImage({ content }) {
  const countryCode = GlobalStore.useState(s => s.currentCountryCode);
  const [formIndex, setFormIndex] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [feedbackMessage, setFeedbackMessage] = useState();
  const { title, description, agreeText, emailFrom, emailTo, parent, fields, subject } = content;
  const formInfo = { fields, emailFrom, parent, subject, emailTo };

  const initialState = {
    name: "",
    licence: "",
    email: "",
    phone: "",
    field: ""
  };

  const [formData, setFormData] = useState(initialState);
  const first = useCms();

  if (first === undefined) return <Loader withMargins />;
  if (first === null) return <Four0Four />;
  const handleSubmitOrChangePage = async e => {
    e.preventDefault();
    if (formIndex === 0) {
      if (!formData.name || !formData.licence || !formData.phone || !formData.field) return;
      return setFormIndex(1);
    } else {
      setIsSubmitting(true);
      try {
        await sendEmail(formData, formInfo);
        setFeedbackMessage("Thank you, your application was sent");
      } catch (error) {
        console.log(error);
      } finally {
        trackCustom("Lead", countryCode, { email: formData.email });
        setIsSubmitting(false);
      }
    }
  };

  return (
    <div id="contactFormImage">
      <div className="left">
        <div className="wrapper">
          <div className="header">
            <p className="title" dangerouslySetInnerHTML={{ __html: title }} />
            <p>{description}</p>
          </div>
          {!feedbackMessage ? (
            <>
              {!isSubmitting ? (
                <form onSubmit={handleSubmitOrChangePage}>
                  <Inputs agreeText={agreeText} setFormData={setFormData} formData={formData} index={formIndex} />
                  <div className="submit">
                    <button className={`submitBtn ${formIndex === 1 ? "submitStep" : ""}`} type="submit">
                      {formIndex === 0 ? <ArrowRight /> : formIndex === 1 ? "Submit" : ""}
                    </button>
                  </div>
                </form>
              ) : (
                <div>
                  <p>Please wait while your application is being sent...</p>
                  <Loader withMargins />
                </div>
              )}
            </>
          ) : (
            <h3>{feedbackMessage}</h3>
          )}
        </div>
      </div>
      <div className="right">
        <LazyLoadImage className="heroImage" src={content.image?.url} alt="join us illustration" effect="blur" />
      </div>
    </div>
  );
}

const Inputs = ({ index, setFormData, formData, agreeText }) => {
  const optionsDropDown = [
    { id: "MPS", title: "Medical Protection Society (MPS)" },
    { id: "NTUC", title: "NTUC Income Medical Indemnity Insurance" },
    { id: "JLT", title: "JLT Medical Practitioners Indemnity Scheme (MPI)" },
    { id: "other", title: "Others" }
  ];

  const locationOptions = [
    { id: "CBD", title: "CBD" },
    { id: "Central", title: "Central" },
    { id: "East", title: "East" },
    { id: "North", title: "North" },
    { id: "West", title: "West" }
  ];

  const handleInputChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSelectChange = (e, name) => {
    setFormData({ ...formData, [name]: e });
  };

  if (index === 0)
    return (
      <>
        <Input
          type="text"
          required
          value={formData.name}
          onChange={handleInputChange}
          name="name"
          placeholder="Full Name"
          className="sm"
        />
        <div>
          <label>
            <Input
              type="text"
              name="licence"
              required
              value={formData.licence}
              onChange={handleInputChange}
              placeholder="Licence Number"
              className="sm"
            />
          </label>
        </div>
        <Input
          type="text"
          value={formData.phone}
          onChange={handleInputChange}
          required
          name="phone"
          placeholder="Phone Number"
          className="sm"
        />
        <Select
          required
          name="field"
          title="Choose a Medical Malpractice Protection"
          defaultValue={formData.field || null}
          list={optionsDropDown}
          onChange={v => handleSelectChange(v, "field")}
          className="sm"
        />
      </>
    );
  else if (index === 1) {
    return (
      <>
        <Input
          type="email"
          required
          value={formData.email}
          onChange={handleInputChange}
          name="email"
          placeholder="Email"
          className="sm"
        />
        <Select
          required
          name="location"
          title="Prefered visit location"
          defaultValue={formData.location || null}
          list={locationOptions}
          onChange={v => handleSelectChange(v, "location")}
          className="sm"
        />
        <CheckBox required id="conditions" title={agreeText} />
      </>
    );
  }
};
